import { render, staticRenderFns } from "./Observer.vue?vue&type=template&id=36fe9fa4&"
import script from "./Observer.vue?vue&type=script&lang=ts&"
export * from "./Observer.vue?vue&type=script&lang=ts&"
import style0 from "./Observer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports